import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const InovamosSection = () => {
  return (
    <section className=" py-16 md:py-2">
      <div className="container">
        <div className="grid md:grid-cols-2 md:gap-16 gap-4 items-center">
          <div className="flex items-center justify-center">
            <ImageSvg
              src="inovamos.svg"
              alt="Inovamos para oferecer uma experiência melhor no transporte de veículos"
              className="max-w-full h-auto"
            />
          </div>
          <div>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              Inovamos para oferecer uma experiência melhor no transporte de
              veículos
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-6">
              A nossa cultura de inovação aliada aos serviços diferenciados que
              oferecemos ao setor de logística, nos permitiu emergir como uma
              solução única, mais eficiente e com maior grau de satisfação e
              sucesso no transporte de veículos.
            </p>

            <Link to="/fazer-cotacao">
              <Button>Fazer cotação</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
